module.exports = __webpack_public_path__ + "img/phone.e78c4b2a.svg";